module.exports = __webpack_public_path__ + "img/logo1.96f9845d.png";